export const REASONS = {
  renovations: {
    id: 'pause.reason.renovations',
    defaultMessage: 'Renovations'
  },
  vacation: {
    id: 'pause.reason.vacation',
    defaultMessage: 'Going on vacation'
  },
  fully_booked: {
    id: 'pause.reason.booked',
    defaultMessage: 'Fully booked'
  },
  changing_listing: {
    id: 'pause.reason.changes',
    defaultMessage: 'Making changes to my listing'
  },
  change_staffing: {
    id: 'pause.reason.staffing',
    defaultMessage: 'Change in staffing'
  },
  not_hosting: {
    id: 'pause.reason.host',
    defaultMessage: 'Don’t want to host right now'
  },
  other: {
    id: 'pause.reason.other',
    defaultMessage: 'Other'
  }
};
